import { render, staticRenderFns } from "./registration-container.vue?vue&type=template&id=2971a358"
import script from "./registration-container.vue?vue&type=script&lang=js"
export * from "./registration-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2971a358')) {
      api.createRecord('2971a358', component.options)
    } else {
      api.reload('2971a358', component.options)
    }
    module.hot.accept("./registration-container.vue?vue&type=template&id=2971a358", function () {
      api.rerender('2971a358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/registration/components/registration-container.vue"
export default component.exports